/**
 * Utilitaires pour D6BattleWidget
 */

import {getValueDice} from '../util/DiceUtil';

/**
 * Évalue une expression D6 SANS lancer de dés pour les nombres simples
 * RÈGLE FONDAMENTALE : "1" doit donner 1, pas 1D lancé
 * Seules les expressions contenant "D" ou "d" sont évaluées comme des dés
 * 
 * @param expression Expression à évaluer (ex: "1", "1D+6", "2D", "10")
 * @returns Valeur numérique évaluée
 */
export const evaluateD6Expression = (expression: string | number | null | undefined): number => {
  if (expression === null || expression === undefined) return 0;
  if (typeof expression === 'number') return expression;
  
  if (typeof expression === 'string') {
    const trimmed = expression.trim();
    
    // Si c'est un nombre simple (pas de D ou d), retourner directement
    if (!/[dD]/.test(trimmed)) {
      const parsed = parseInt(trimmed, 10);
      return isNaN(parsed) ? 0 : parsed;
    }
    
    // Si c'est une expression de dés (contient D ou d), utiliser getValueDice
    // getValueDice gère correctement les nombres simples aussi (retourne le nombre sans lancer)
    try {
      return getValueDice(trimmed);
    } catch (e) {
      console.error('[evaluateD6Expression] Erreur getValueDice:', e);
      return 0;
    }
  }
  
  return 0;
};

/**
 * Parse une valeur (string, number, null, undefined) en number
 * Gère aussi les expressions de dés (contient D ou d) - LANCE LES DÉS
 * 
 * ⚠️ ATTENTION : Cette fonction LANCE les dés pour les expressions contenant D/d
 * Pour évaluer SANS lancer (nombres simples), utiliser evaluateD6Expression
 */
export const parseValue = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') return value;
  
  // Si c'est une expression de dés (contient D ou d), utiliser getValueDice
  if (typeof value === 'string' && /[dD]/.test(value)) {
    try {
      return getValueDice(value);
    } catch (e) {
      console.error('[parseValue] Erreur getValueDice:', e);
      return 0;
    }
  }
  
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }
  return null;
};
